<div class="container">
    <h1>Login</h1>  
    <input [(ngModel)]="loginDto.username" type="text" placeholder="username" class="field">
    <input [(ngModel)]="loginDto.password" type="password" placeholder="password" class="field">
    <div class="remember-me">Remember me<input [(ngModel)]="loginDto.rememberMe" [value]="loginDto.rememberMe" type="checkbox"/></div>
    <button class="btn" (click)="login(loginDto)">Login</button>
    <div *ngIf="invalidLogin">Invalid User/Password</div>    
</div>